module.exports = __webpack_public_path__ + "static/media/Wildlife Photographer.eb487532.jpg";